"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "incisa-scapaccino": {
    "b2c06a86": [{
      "hkey": "c94a8f68",
      "slug": "borgo-impero-san-lorenzo",
      "name": "Borgo Impero-San Lorenzo",
      "primary": true,
      "skipSearch": false
    }],
    "borgo-impero": [{
      "hkey": "c94a8f68",
      "slug": "borgo-impero-san-lorenzo",
      "name": "Borgo Impero-San Lorenzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "e1dded32": [{
      "hkey": "2d114543",
      "slug": "borgo-villa",
      "name": "Borgo Villa",
      "primary": true,
      "skipSearch": false
    }],
    "borgo-villa-il-poggio": [{
      "hkey": "2d114543",
      "slug": "borgo-villa",
      "name": "Borgo Villa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "138cfb23": [{
      "hkey": "7c51c5cf",
      "slug": "ghiare-madonna",
      "name": "Ghiare-Madonna",
      "primary": true,
      "skipSearch": false
    }],
    "borgo-ghiare": [{
      "hkey": "7c51c5cf",
      "slug": "ghiare-madonna",
      "name": "Ghiare-Madonna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "incisa-scapaccino"
    }],
    "6f6b5003": [{
      "hkey": "7c51c5cf",
      "slug": "ghiare-madonna",
      "name": "Ghiare-Madonna",
      "primary": true,
      "skipSearch": false
    }],
    "borgo-madonna": [{
      "hkey": "7c51c5cf",
      "slug": "ghiare-madonna",
      "name": "Ghiare-Madonna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "incisa-scapaccino"
    }],
    "734846f6": [{
      "hkey": "99f88457",
      "slug": "incisa-scapaccino",
      "name": "Incisa Scapaccino",
      "primary": true,
      "skipSearch": false
    }],
    "regione-collina": [{
      "hkey": "99f88457",
      "slug": "incisa-scapaccino",
      "name": "Incisa Scapaccino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;